import DotNetObject = DotNet.DotNetObject;
import { SLA } from '@crimsontide/core/client/interfaces'

export const SlaService = (() => {
  let dotNetObj: DotNetObject;
  let cachedSlas: SLA[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getAll = async (useCache: boolean = true): Promise<SLA[]> => {
    if (useCache && cachedSlas != null)
      return cachedSlas;

    if (dotNetObj) {
      cachedSlas = await dotNetObj.invokeMethodAsync<SLA[]>('GetAllAsync');
      return cachedSlas;
    } else {
      throw 'SLA DotNet Object Reference has not yet been implemented';
    }
  };

  const getByContractIds = async (contractIds: string[]): Promise<SLA[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<SLA[]>('GetByContractIdsAsync', contractIds);
    } else {
      throw 'SLA DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getAll,
    getByContractIds,
  };
})();
